import type { ToolCallMessagePartComponent } from '@assistant-ui/react'
import { ArtifactView } from '@bridge/app-host'
import type { ToolArtifact } from '@web/adapter/toThreadMessages'

export const GreetingArtifactTool: ToolCallMessagePartComponent = (props) => {
  const result = (props.artifact as ToolArtifact | undefined)?.appTool
  if (!result?.verified || !result.bindingId || !result.artifactId)
    return <p>Saved greeting result unavailable.</p>
  const bindingId = result.bindingId
  return (
    <ArtifactView
      bindingId={bindingId}
      artifactId={result.artifactId}
      onInspect={(revision, latest) =>
        window.dispatchEvent(
          new CustomEvent('bridge:inspect', {
            detail: { bindingId, revision, latest },
          }),
        )
      }
    />
  )
}
